// @flow

import React from 'react'
import Layout from '../../../../components/Layout/index'
import Header from '../../../../modules/Header'
import Footer from '../../../../modules/Footer'
import { useIntl } from 'gatsby-plugin-intl'
import { applyStylingHoc, type StyleOuterProps, type StyleProps } from '@fcse/tsbob/dist/lib/styling'
import SubpageHeroTeaser from '../../../../components/SubpageHeroTeaser'
import IntroTeaser from '../../../../components/IntroTeaser'
import Services from '../../../../components/Services'
import ServicesNav from '../../../../components/ServicePages/ServicesNav'
import IntegrationExample from '../../../../components/ServicePages/IntegrationExample'

import messages from '../../../../components/ServicePages/ServicePages.lang'
import metaDescription from '../../../../messages/pageMetaDescriptions.lang'
import pageTitle from '../../../../messages/pageTitles.lang'
import baseStyles from '../../../../components/ServicePages/ServicePages.scss'
import SEO from '../../../../components/seo'
import { StaticImage } from 'gatsby-plugin-image'

const IntroImage = (
  <StaticImage
    src="../../../../images/services/subpages/hcms-integration.jpg"
    objectFit="cover"
    alt=""
    className="image"
  />
)

const HeroTeaserImage = (
  <StaticImage
    src="../../../../images/heroteaser/service_heroteaser_bg_desktop.jpg"
    objectFit="cover"
    alt=""
    className="image"
  />
)

const StewaImg = (
  <StaticImage src="../../../../images/clientlogos/act-stewa.png" alt="" objectFit="contain" className="image" />
)

import JazImgSrc from '../../../../images/clientlogos/logo-jaz-hotels.svg'
const JazImg = <img src={JazImgSrc} alt="" className="image" />

import SentidoImgSrc from '../../../../images/clientlogos/logo-sentido.svg'
const SentidoImg = <img src={SentidoImgSrc} alt="" className="image" />

const SreiseweltImg = (
  <StaticImage src="../../../../images/clientlogos/logo-s-reisewelt.png" alt="" objectFit="contain" className="image" />
)

type Props = {
  ...StyleProps
}

const ServicePage = ({ styles }: Props) => {
  const { formatMessage, locale } = useIntl()

  return (
    <Layout footer={<Footer />} header={<Header withTeaser />}>
      <SEO
        title={formatMessage(pageTitle.TitleStrapi)}
        description={formatMessage(metaDescription.strapiDescription)}
        lang={locale}
      />
      <ServicesNav />
      <div className={styles.root}>
        <SubpageHeroTeaser title={formatMessage(messages.hcmsIntegrationTitle)} image={HeroTeaserImage} />
        <IntroTeaser
          title={formatMessage(messages.strapiIntroTitle)}
          copy={
            <div className={styles.text}>
              <IntegrationExample
                exampleLogo={SreiseweltImg}
                exampleText={formatMessage(messages.strapiSMarktExampleText).replaceAll("'", '')}
                exampleTech={
                  <>
                    ReactJS, <a href={`/${locale}/products/travelsandbox/`}>TravelSandbox®</a> Quickstart, freshMS,
                    Fusion
                  </>
                }
                exampleLive={formatMessage(messages.strapiSMarktExampleLive)}
                exampleStart={formatMessage(messages.strapiSMarktExampleStart)}
              />
              <IntegrationExample
                exampleLogo={SentidoImg}
                exampleText={formatMessage(messages.strapiSentidoExampleText).replaceAll("'", '')}
                exampleTech={
                  <>
                    ReactJS, <a href={`/${locale}/products/travelsandbox/`}>TravelSandbox®</a> Quickstart, freshMS
                  </>
                }
                exampleLive={formatMessage(messages.strapiSentidoExampleLive)}
                exampleStart={formatMessage(messages.strapiSentidoExampleStart)}
              />
              <IntegrationExample
                exampleLogo={JazImg}
                exampleText={formatMessage(messages.strapiTravcoExampleText).replaceAll("'", '')}
                exampleTech={
                  <>
                    {/* eslint-disable-next-line max-len */}
                    ReactJS, <a href={`/${locale}/products/travelsandbox/`}>TravelSandbox®</a> Quickstart, freshMS,
                    Fusion, Sabre Synxis
                  </>
                }
                exampleLive={formatMessage(messages.strapiTravcoExampleLive)}
                exampleStart={formatMessage(messages.strapiTravcoExampleStart)}
              />
              <IntegrationExample
                description={messages.strapiDescription}
                integrationTitle={formatMessage(messages.strapiIntegrationTitle)}
                exampleTitle={formatMessage(messages.integrationExampleTitle)}
                exampleLogo={StewaImg}
                exampleText={formatMessage(messages.strapiExampleText).replaceAll("'", '')}
                exampleTech={
                  <>
                    Strapi, <a href={`/${locale}/products/travelsandbox/`}>TravelSandbox®</a> Quickstart, ReactJS
                  </>
                }
              />
            </div>
          }
          image={IntroImage}
          fullWidth
        />
      </div>
      <Services
        services={[
          'consulting',
          'conceptStrategy',
          'design',
          'development',
          'systemIntegration',
          'systemEngineering',
          'appDevelopment',
          'hcmsIntegration'
        ]}
      />
    </Layout>
  )
}

export default applyStylingHoc(baseStyles)<$Diff<Props, StyleProps> & StyleOuterProps, Function>(ServicePage)
